const momenttimethai = (data) => {
  var moment = require('moment')
  return (moment(data).tz('Pacific/Kiritimati').lang('th').format('LT'))
}
const momentdatethai = (data) => {
  var moment = require('moment')
  return moment(data).tz('Pacific/Kiritimati').lang('th').format('ll')
}

const momenttimethaiformnow = (data) => {
  var moment = require('moment')
  return moment(moment(data).tz('Pacific/Kiritimati').format().replace(/T/g, ' '), 'YYYY-MM-DD h:mm:ss').fromNow()
}
export default {
  momenttimethai,
  momentdatethai,
  momenttimethaiformnow
}



// WEBPACK FOOTER //
// ./src/services/momentthai.js